export default "__VITE_ASSET__ecf059f4__"